module.exports = __webpack_public_path__ + "static/media/fa-brands-400.6a44bb7c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-brands-400.woff2
// module id = 765
// module chunks = 0